import {
    GET_ONGOING_BOOKINGS,
    GET_PENDING_BOOKINGS,
    GET_COMPLETED_BOOKINGS,
    GET_CANCELLED_BOOKINGS,
    LOAD_MORE_ONGOING_BOOKINGS,
    LOAD_MORE_PENDING_BOOKINGS,
    LOAD_MORE_COMPLETED_BOOKINGS,
    LOAD_MORE_CANCELLED_BOOKINGS,
    CLEAR_BOOKINGS,
} from "../actions/types";

let bookingsInitial = {
    current_page: null,
    data: [],
    first_page_url: null,
    from: null,
    last_page: null,
    last_page_url: null,
    links: [],
    next_page_url: null,
    path: null,
    per_page: null,
    prev_page_url: null,
    to: null,
    total: null,
};

let initialState = {
    pending: { ...bookingsInitial },
    ongoing: { ...bookingsInitial },
    completed: { ...bookingsInitial },
    cancelled: { ...bookingsInitial },
};

const bookings = (state = initialState, action) => {
    switch (action.type) {
        case GET_PENDING_BOOKINGS:
            return {
                ...state,
                pending: action.payload,
            };
        case GET_ONGOING_BOOKINGS:
            return {
                ...state,
                ongoing: action.payload,
            };
        case GET_COMPLETED_BOOKINGS:
            return {
                ...state,
                completed: action.payload,
            };
        case GET_CANCELLED_BOOKINGS:
            return {
                ...state,
                cancelled: action.payload,
            };
        case LOAD_MORE_PENDING_BOOKINGS:
            return {
                ...state,
                pending: {
                    ...action.payload,
                    data: [...state.pending.data, ...action.payload.data],
                },
            };
        case LOAD_MORE_ONGOING_BOOKINGS:
            return {
                ...state,
                ongoing: {
                    ...action.payload,
                    data: [...state.ongoing.data, ...action.payload.data],
                },
            };
        case LOAD_MORE_COMPLETED_BOOKINGS:
            return {
                ...state,
                completed: {
                    ...action.payload,
                    data: [...state.completed.data, ...action.payload.data],
                },
            };
        case LOAD_MORE_CANCELLED_BOOKINGS:
            return {
                ...state,
                cancelled: {
                    ...action.payload,
                    data: [...state.cancelled.data, ...action.payload.data],
                },
            };
        case CLEAR_BOOKINGS:
            return initialState;
        default:
            return state;
    }
};

export default bookings;
